// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playkit-titleContainer{display:inline-block;max-width:100%}.playkit-titleContainer[data-player-size=tiny]{display:none}", ""]);
// Exports
exports.locals = {
	"titleContainer": "playkit-titleContainer"
};
module.exports = exports;
